import authReducer from "@mods/userManagement/auth/authSlice";
import commonSlice from "./commonSlice";
import filterOptionsReducer from "./filterOptionsSlice";
const reducer = {
  auth: authReducer,
  common: commonSlice,
  filterOptions: filterOptionsReducer
}

export default reducer;